<!-- Copy of the admin portal's drone-resource-upload-modal, minus the Access
     switch — operator uploads are always registered as shared. -->
<div class="modal-backdrop" (click)="onBackdropClick()"></div>

<div class="modal-dialog modal-dialog-centered modal-lg" role="dialog" aria-modal="true"
     aria-labelledby="droneResourceModalTitle" (click)="$event.stopPropagation()">
    <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
            <h5 class="modal-title" id="droneResourceModalTitle">Attach Resource to Drone</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="onClose()" [disabled]="uploading()"></button>
        </div>

        <!-- Body -->
        <div class="modal-body">
            @if (errorMessage()) {
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                {{ errorMessage() }}
                <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage.set('')"></button>
            </div>
            }

            <form [formGroup]="resourceForm">
                <div class="row g-3 mb-3">
                    <div class="col-md-6">
                        <label for="resourceType" class="form-label">
                            Resource Type <span class="text-danger">*</span>
                        </label>
                        <select
                        id="resourceType"
                        class="form-select"
                        [class.is-invalid]="showError('resourceType')"
                        formControlName="resourceType">
                        <option value="" disabled>Select a type…</option>
                        @for(type of resourceTypes; track type) {
                            <option [value]="type">
                                {{ type | removeDash | titlecase }}
                            </option>
                        }</select>
                        @if (showError('resourceType')) {
                            <div class="invalid-feedback">Pick a resource type.</div>
                        }
                    </div>
                    <div class="col-md-6">
                        <label for="otherType" class="form-label">
                            Resource Type if "Other"
                        </label>
                        <input
                        type="text"
                        id="otherType"
                        class="form-control"
                        [class.is-invalid]="showError('otherType')"
                        formControlName="otherType"
                        >
                        @if (showError('otherType')) {
                            <div class="invalid-feedback">Name the resource type.</div>
                        }
                    </div>
                </div>

                <div class="mb-3">
                    <label for="caption" class="form-label">Description</label>
                    <input
                        type="text"
                        id="caption"
                        class="form-control"
                        placeholder="Optional — e.g. 2026 annual inspection"
                        formControlName="caption">
                </div>

                 <!-- File Upload -->
                <div class="row g-3 mb-3">
                    <div class="col-12">
                        <label for="fileUpload" class="form-label">
                            Resource file
                        </label>
                        <input
                            type="file"
                            id="fileUpload"
                            class="form-control"
                            (change)="onFileSelected($event)"
                            accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.doc,.docx,.xls,.xlsx,.txt"
                            [disabled]="uploading()">
                        <small class="form-text text-muted">
                        PDF, image, or document. Max {{ maxFileSizeLabel }}.
                        </small>
                        @if (selectedFile()) {
                            <div class="mt-2 text-muted">
                                <i class="bi bi-file-earmark me-1"></i>
                                {{ selectedFile()!.name }} ({{ formatFileSize(selectedFile()!.size) }})
                            </div>
                        }
                    </div>
                </div>
            </form>
        </div>

        <!-- Footer -->
         <div class="modal-footer">
            <button
            type="button"
            class="btn btn-secondary"
            (click)="onClose()"
            [disabled]="uploading()">
                Cancel
            </button>
            <button
            type="button"
            class="btn btn-primary"
            (click)="onSubmit()"
            [disabled]="uploading() || !selectedFile()">
            @if (uploading()) {
            <span class="spinner-border spinner-border-sm me-2" role="status">
                <span class="visually-hidden">Uploading...</span>
            </span>
            }
            Submit</button>
         </div>
    </div>
</div>
